var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.8333V4.99992C16.6666 4.07944 15.9204 3.33325 14.9999 3.33325H4.99992C4.07944 3.33325 3.33325 4.07944 3.33325 4.99992V10.8333M16.6666 10.8333V14.9999C16.6666 15.9204 15.9204 16.6666 14.9999 16.6666H4.99992C4.07944 16.6666 3.33325 15.9204 3.33325 14.9999V10.8333M16.6666 10.8333H14.5118C14.2907 10.8333 14.0788 10.921 13.9225 11.0773L11.9107 13.0892C11.7544 13.2455 11.5424 13.3333 11.3214 13.3333H8.67843C8.45742 13.3333 8.24545 13.2455 8.08917 13.0892L6.07733 11.0773C5.92105 10.921 5.70909 10.8333 5.48807 10.8333H3.33325",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.710f18b097b80c5abb2290fd8a3286ca.svg";
export { ForwardRef as ReactComponent };